module.exports = __webpack_public_path__ + "static/media/dotsvertical.973e0db7.png";